export default {
  setMachines(state, machines) {
    state.machines = machines;
  },
  setBasicData(state, data) {
    state.basicData = data;
  },
  setOrderList(state, list) {
    state.orderList = list;
  },
  setDeliveryTypes(state, types) {
    state.deliveryTypes = types;
  },
  setDeliveryTypeForOrder(state, { orderId, deliveryTypeId }) {
    state.orderList.map(o => {
      if (o.id === orderId) {
        o.deliveryTypeId = deliveryTypeId;
      }
      return o;
    });
  },
  setAmountOfCanisters(state, { orderId, amount }) {
    state.orderList.map(o => {
      if (o.id === orderId) {
        o.amountOfCanisters = amount;
      }
      return o;
    });
  },
  setOnHoldDeliveryDetails(state, details) {
    state.onHoldDeliveryDetails = details;
  },
  setPriceList(state, list) {
    state.priceList = list;
  },
  setFreeContingent(state, free) {
    state.freeContingent = free;
  },
  setMachineId(state, id) {
    state.machineId = id;
  },
  setReferenceNumber(state, referenceNumber) {
    state.referenceNumber = referenceNumber;
  },
  setMachineNumber(state, machineNumber) {
    state.machineNumber = machineNumber;
  }
};
